import Http from '@/services/http';
import { SupervisionDigitalNetworkResponse } from 'sigma-mappings';

const urls = {
  digitalNetwork: assetId => `/ativo/${assetId}/rededigital`,
};

export default {
  getDigitalNetwork(assetId) {
    const http = new Http();
    return http.get(urls.digitalNetwork(assetId))
      .then(({ data }) => data.map(item => new SupervisionDigitalNetworkResponse(item)));
  },
};
